import React from 'react';
import { Waypoint } from 'react-waypoint';
import styled, { css } from 'styled-components';
import { Box, BoxProps } from '@99designs/emu';
import { trackEvent } from '@99designs/tracking';

interface PageSectionProps extends BoxProps {
    children: React.ReactNode;
    id: string;
    pageName: string;
    backgroundGradientColors?: [string, string];
    onEnter?: (arg0: string) => void;
}

const StyledSection = styled(Box)<{ backgroundGradientColors: [string, string] }>(
    ({ backgroundGradientColors }) => css`
        position: relative;
        ${backgroundGradientColors
            ? `background: linear-gradient(180deg, ${backgroundGradientColors[0]} 0%, ${backgroundGradientColors[1]} 100%);`
            : ``}
    `
);

const PageSection = ({
    id,
    children,
    pageName,
    backgroundGradientColors,
    onEnter,
    ...props
}: PageSectionProps) => {
    let scrollableAncestor = null;
    if (typeof window !== 'undefined') {
        scrollableAncestor = window;
    }

    return (
        <Waypoint
            scrollableAncestor={scrollableAncestor}
            topOffset={'70%'}
            bottomOffset={'30%'}
            onEnter={() => {
                onEnter && onEnter(id);
                trackEvent('Page Scrolled', {
                    page_name: pageName,
                    to_element: id,
                });
            }}
            fireOnRapidScroll={false}
        >
            <StyledSection id={id} backgroundGradientColors={backgroundGradientColors!} {...props}>
                {children}
            </StyledSection>
        </Waypoint>
    );
};

export default PageSection;
